import {get} from '@yandex-delivery/utils'

import type {CustomParcelSizes, NddClaimParcels, Parcel} from 'src/shared/types'

import {toPhysicalDimensions} from './to-physical-dimensions'

function toBarcode(barcode?: string, parcelIndex = 0) {
  return barcode ? `${barcode}-${parcelIndex}` : ''
}

export function fromNddParcel(parcels: Parcel[], orderNumber?: string, customParcelSizes?: CustomParcelSizes) {
  return parcels.reduce<NddClaimParcels>((acc, parcel, index) => {
    if (parcel.size === undefined) {
      return acc
    }

    const size = parcel.size === 'custom' ? parcel.dimensions : get(parcel.size, customParcelSizes)
    const barcode = parcel.barcode || orderNumber

    acc.push({
      barcode: toBarcode(barcode, index),
      physical_dims: toPhysicalDimensions(size),
    })

    return acc
  }, [])
}
